import { createTheme as y } from "@mui/material/styles";
import { aj as l, ak as T, al as P, am as R, an as z, ao as W, ap as h, aq as L, ar as O, p as H } from "./Slider-vVmtecg6.js";
import { capitalize as f } from "@mui/material";
import { c as u, C as g, a as A } from "./Tab-CO75KpXL.js";
import { b as p, a as d, C as v } from "./shadows-JVyVGdzD.js";
import { r as e } from "./roundings-rAN_HXvA.js";
import { s as i } from "./spacings-C27fg6SF.js";
import { s as D } from "./SelectListItemEndElement-iD_Iv3zm.js";
import "react/jsx-runtime";
import "react";
import "@mui/material/CssBaseline";
import "@mui/material/useAutocomplete";
import "@fortawesome/pro-regular-svg-icons";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Box";
import "@mui/material/Typography";
import "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@mui/material/Button";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Chip";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "@mui/material/Slider";
const E = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1280,
  xl: 1536,
  xxl: 1920
}, F = (o) => ({
  defaultProps: {
    variant: "body2"
  },
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {},
    /** Styles applied to the root element if `variant="body2"`. */
    body2: {},
    /** Styles applied to the root element if `variant="body1"`. */
    body1: {},
    /** Styles applied to the root element if `variant="caption"`. */
    caption: {},
    /** Styles applied to the root element if `variant="button"`. */
    button: {},
    /** Styles applied to the root element if `variant="h1"`. */
    h1: {},
    /** Styles applied to the root element if `variant="h2"`. */
    h2: {},
    /** Styles applied to the root element if `variant="h3"`. */
    h3: {},
    /** Styles applied to the root element if `variant="h4"`. */
    h4: {},
    /** Styles applied to the root element if `variant="h5"`. */
    h5: {},
    /** Styles applied to the root element if `variant="h6"`. */
    h6: {},
    /** Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: {},
    /** Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: {},
    /** Styles applied to the root element if `variant="overline"`. */
    overline: {},
    /** Styles applied to the root element if `variant="inherit"`. */
    inherit: {},
    /** Styles applied to the root element if `align="left"`. */
    alignLeft: {},
    /** Styles applied to the root element if `align="center"`. */
    alignCenter: {},
    /** Styles applied to the root element if `align="right"`. */
    alignRight: {},
    /** Styles applied to the root element if `align="justify"`. */
    alignJustify: {},
    /** Styles applied to the root element if `nowrap={true}`. */
    noWrap: {},
    /** Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {},
    /** Styles applied to the root element if `paragraph={true}`. */
    paragraph: {}
  }
}), b = (o) => ({
  "& .MuiButton-startIcon": {
    marginLeft: i.none,
    marginRight: o
  },
  "& .MuiButton-endIcon": {
    marginRight: i.none,
    marginLeft: o
  }
}), V = (o) => ({
  defaultProps: {
    size: u.medium,
    variant: "contained",
    color: "primary",
    disableRipple: !0
  },
  variants: [
    {
      props: { size: u.xs },
      style: {
        fontSize: "12px",
        lineHeight: "16px",
        padding: "0 6px"
      }
    },
    {
      props: { size: u.xl },
      style: {
        fontSize: "16px",
        lineHeight: "24px",
        // TODO: understand why this padding is not aligned to the DS spacings
        padding: "12px 18px"
      }
    },
    {
      props: { size: u.xxl },
      style: {
        fontSize: "18px",
        lineHeight: "28px",
        // TODO: understand why this padding is not aligned to the DS spacings
        padding: "16px 22px"
      }
    }
  ],
  styleOverrides: {
    text: {
      fontWeight: o.typography.fontWeightSemibold
    },
    /** Styles applied to the root element if `variant="text"` and `color="inherit"`. */
    textInherit: {},
    /** Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: ({ ownerState: r }) => ({
      border: "1px solid transparent",
      color: o.palette.primary[700],
      "&:hover": {
        background: r.isLink ? "transparent" : o.palette.primary[50],
        color: `${o.palette.primary[800]} !important`
      },
      "&:focus-visible": {
        background: "transparent",
        color: o.palette.primary[700]
      },
      "&.Mui-disabled": {
        color: o.palette.grey[400],
        background: "transparent"
      }
    }),
    /** Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: ({ ownerState: r }) => ({
      border: "1px solid transparent",
      color: o.palette.grey[600],
      "&:active, &:hover": {
        background: r.isLink ? "transparent" : o.palette.grey[50],
        color: `${o.palette.grey[700]} !important`
      },
      "&:focus-visible": {
        background: "transparent",
        color: o.palette.grey[600]
      },
      "&.Mui-disabled": {
        color: o.palette.grey[400],
        background: "transparent"
      }
    }),
    /** Styles applied to the root element if `variant="text"` and `color="success"`. */
    textSuccess: {},
    /** Styles applied to the root element if `variant="text"` and `color="error"`. */
    textError: ({ ownerState: r }) => ({
      border: "1px solid transparent",
      color: o.palette.error[700],
      "&:active, &:hover": {
        background: r.isLink ? "transparent" : o.palette.error[50],
        color: `${o.palette.error[800]} !important`
      },
      "&:focus-visible": {
        background: "transparent",
        color: o.palette.error[700]
      },
      "&.Mui-disabled": {
        color: o.palette.grey[400],
        background: "transparent"
      }
    }),
    /** Styles applied to the root element if `variant="text"` and `color="info"`. */
    textInfo: {},
    /** Styles applied to the root element if `variant="text"` and `color="warning"`. */
    textWarning: {},
    /** Styles applied to the root element if `variant="outlined"`. */
    outlined: {},
    /** Styles applied to the root element if `variant="outlined"` and `color="inherit"`. */
    outlinedInherit: {},
    /** Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: o.palette.primary[700],
      border: `1px solid ${o.palette.primary[300]}`,
      background: o.palette.primary[50],
      boxShadow: p.xs,
      "&:active, &:hover": {
        color: o.palette.primary[800],
        border: `1px solid ${o.palette.primary[300]}`,
        background: o.palette.primary[100],
        boxShadow: p.xs
      },
      "&:focus-visible": {
        color: o.palette.primary[700],
        border: `1px solid ${o.palette.primary[300]}`,
        background: o.palette.primary[50],
        boxShadow: d.primaryXs
      },
      "&.Mui-disabled": {
        border: `1px solid ${o.palette.grey[200]}`,
        background: o.palette.common.white
      }
    },
    /** Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: o.palette.grey[700],
      background: o.palette.common.white,
      border: `1px solid ${o.palette.grey[300]}`,
      boxShadow: p.xs,
      "&:active, &:hover": {
        border: `1px solid ${o.palette.grey[300]}`,
        background: o.palette.grey[50],
        boxShadow: p.xs
      },
      "&:focus-visible": {
        border: `1px solid ${o.palette.grey[300]}`,
        boxShadow: d.primaryXs
      },
      "&.Mui-disabled": {
        border: `1px solid ${o.palette.grey[200]}`
      }
    },
    /** Styles applied to the root element if `variant="outlined"` and `color="success"`. */
    outlinedSuccess: {},
    /** Styles applied to the root element if `variant="outlined"` and `color="error"`. */
    outlinedError: {
      color: o.palette.error[700],
      border: `1px solid ${o.palette.error[300]}`,
      boxShadow: p.xs,
      "&:active, &:hover": {
        border: `1px solid ${o.palette.error[300]}`,
        background: o.palette.error[50],
        boxShadow: p.xs
      },
      "&:focus-visible": {
        border: `1px solid ${o.palette.error[300]}`,
        background: o.palette.common.white,
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 2px rgba(240, 68, 56, 0.34)"
      },
      "&.Mui-disabled": {
        border: `1px solid ${o.palette.grey[200]}`,
        background: o.palette.common.white
      }
    },
    /** Styles applied to the root element if `variant="outlined"` and `color="info"`. */
    outlinedInfo: {},
    /** Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
    outlinedWarning: {},
    /** Styles applied to the root element if `variant="contained"`. */
    contained: {
      border: "1px solid transparent",
      boxShadow: p.xs,
      "&:active, &:hover": {
        border: `1px solid ${o.palette.primary[700]}`,
        background: o.palette.primary[700],
        boxShadow: p.xs
      },
      "&:focus-visible": {
        border: `1px solid ${o.palette.primary[600]}`,
        background: o.palette.primary[600],
        boxShadow: d.primaryXs
      },
      "&.Mui-disabled": {
        border: `1px solid ${o.palette.grey[200]}`,
        background: o.palette.grey[100]
      }
    },
    /** Styles applied to the root element if `variant="contained"` and `color="inherit"`. */
    containedInherit: {},
    /** Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: o.palette.common.white,
      background: o.palette.primary[600]
    },
    /** Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {},
    /** Styles applied to the root element if `variant="contained"` and `color="success"`. */
    containedSuccess: {},
    /** Styles applied to the root element if `variant="contained"` and `color="info"`. */
    containedInfo: {},
    /** Styles applied to the root element if `variant="contained"` and `color="error"`. */
    containedError: {
      border: "1px solid transparent",
      background: o.palette.error[600],
      color: o.palette.common.white,
      boxShadow: p.xs,
      "&:active, &:hover": {
        border: `1px solid ${o.palette.error[700]}`,
        background: o.palette.error[700],
        boxShadow: p.xs
      },
      "&:focus-visible": {
        border: `1px solid ${o.palette.error[600]}`,
        background: o.palette.error[600],
        boxShadow: d.error
      },
      "&.Mui-disabled": {
        border: `1px solid ${o.palette.grey[200]}`,
        background: o.palette.grey[100]
      }
    },
    /** Styles applied to the root element if `variant="contained"` and `color="warning"`. */
    containedWarning: {},
    /** Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {},
    /** State class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the root element if `color="inherit"`. */
    colorInherit: {},
    /** Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {},
    /** Styles applied to the root element if `size="medium"` and `variant="text"`. */
    textSizeMedium: {},
    /** Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {},
    /** Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {},
    /** Styles applied to the root element if `size="medium"` and `variant="outlined"`. */
    outlinedSizeMedium: {},
    /** Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {},
    /** Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {},
    /** Styles applied to the root element if `size="medium"` and `variant="contained"`. */
    containedSizeMedium: {},
    /** Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: ({ ownerState: r }) => ({
      fontSize: "14px",
      lineHeight: "20px",
      padding: o.spacing(i.md, i.lg),
      ...l(r.isDotLeading ? 10 : 20),
      ...b(
        r.isDotLeading ? o.spacing(i.md) : o.spacing(i.xs)
      )
    }),
    /** Styles applied to the root element if `size="medium"`. */
    sizeMedium: ({ ownerState: r }) => ({
      fontSize: "14px",
      lineHeight: "20px",
      padding: "10px 14px",
      ...l(r.isDotLeading ? 10 : 20),
      ...b(
        r.isDotLeading ? o.spacing(i.md) : o.spacing(i.sm)
      )
    }),
    /** Styles applied to the root element if `size="large"`. */
    sizeLarge: ({ ownerState: r }) => ({
      fontSize: "16px",
      lineHeight: "24px",
      // TODO: understand why this padding is not aligned to the DS spacings
      padding: "10px 16px",
      ...l(r.isDotLeading ? 10 : 20),
      ...b(
        r.isDotLeading ? o.spacing(i.md) : o.spacing(i.sm)
      )
    }),
    /** Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},
    /** Styles applied to the startIcon element if supplied. */
    startIcon: {},
    /** Styles applied to the endIcon element if supplied. */
    endIcon: {},
    /** Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {},
    /** Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {},
    /** Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {},
    root: ({ ownerState: r }) => ({
      ...!!r.isUppercased && { textTransform: "uppercase" },
      transition: "background 0.2s linear, box-shadow 0.2s linear, border 0.2s linear, color 0.2s linear",
      fontWeight: o.typography.fontWeightSemibold,
      borderRadius: o.rounding(e.full),
      [`&.MuiButton-size${f(u.xs)}`]: {
        ...b(o.spacing(i.xs))
      },
      [`&.MuiButton-size${f(u.xl)}`]: {
        ...l(r.isDotLeading ? 10 : 20),
        ...b(o.spacing(i.md))
      },
      [`&.MuiButton-size${f(u.xxl)}`]: {
        ...l(r.isDotLeading ? 10 : 24),
        ...b(o.spacing(i.lg))
      },
      "& .Mui-disabled": {
        color: o.palette.grey[400]
      }
    })
  }
}), X = (o) => ({
  defaultProps: {
    variant: "outlined",
    size: "medium",
    disableRipple: !0
  },
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {},
    /** Styles applied to the root element if `variant="contained"`. */
    contained: {},
    /** Styles applied to the root element if `variant="outlined"`. */
    outlined: {},
    /** Styles applied to the root element if `variant="text"`. */
    text: {},
    /** Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {},
    /** State class applied to the child elements if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the first button in the button group. */
    firstButton: {
      borderTopLeftRadius: o.rounding(e.md),
      borderBottomLeftRadius: o.rounding(e.md)
    },
    /** Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},
    /** Styles applied to the root element if `orientation="vertical"`. */
    vertical: {},
    /** Styles applied to the children. */
    grouped: ({ ownerState: r }) => {
      const { isIconsOnly: t, isDotLeading: n } = r, a = o.palette.grey, s = a[t ? 500 : 700], c = a[t ? 700 : 800], M = a[t ? 500 : 700], S = a[400], k = n ? 10 : 20, m = (I) => n ? o.palette.success[500] : I;
      return {
        "& .MuiButton-startIcon": {
          marginRight: o.spacing(i.md)
        },
        "& .MuiButton-endIcon": {
          marginLeft: o.spacing(i.md)
        },
        background: o.palette.common.white,
        padding: o.spacing(i.md, t ? i.lg : i.xl),
        fontWeight: o.typography.fontWeightSemibold,
        lineHeight: "20px",
        fontSize: 14,
        minHeight: 40,
        color: s,
        "& svg": {
          width: k,
          height: k,
          color: m(s)
        },
        border: `1px solid ${a[300]}`,
        "&:active, &:hover": {
          background: a[50],
          border: `1px solid ${a[300]}`,
          color: c,
          "& svg": {
            color: m(c)
          }
        },
        "&:focus-visible": {
          background: o.palette.common.white,
          border: `1px solid ${a[300]}`,
          color: M,
          "& svg": {
            color: m(M)
          }
        },
        "&.Mui-disabled": {
          border: `1px solid ${a[400]}`,
          color: S,
          "& svg": {
            color: S
          }
        }
      };
    },
    /** Styles applied to the children if `orientation="horizontal"`. */
    groupedHorizontal: {},
    /** Styles applied to the children if `orientation="vertical"`. */
    groupedVertical: {},
    /** Styles applied to the children if `variant="text"`. */
    groupedText: {},
    /** Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
    groupedTextHorizontal: {},
    /** Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
    groupedTextVertical: {},
    /** Styles applied to the children if `variant="text"` and `color="primary"`. */
    groupedTextPrimary: {},
    /** Styles applied to the children if `variant="text"` and `color="secondary"`. */
    groupedTextSecondary: {},
    /** Styles applied to the children if `variant="outlined"`. */
    groupedOutlined: {},
    /** Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
    groupedOutlinedHorizontal: {},
    /** Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
    groupedOutlinedVertical: {},
    /** Styles applied to the children if `variant="outlined"` and `color="primary"`. */
    groupedOutlinedPrimary: {},
    /** Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
    groupedOutlinedSecondary: {},
    /** Styles applied to the children if `variant="contained"`. */
    groupedContained: {},
    /** Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
    groupedContainedHorizontal: {},
    /** Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
    groupedContainedVertical: {},
    /** Styles applied to the children if `variant="contained"` and `color="primary"`. */
    groupedContainedPrimary: {},
    /** Styles applied to the children if `variant="contained"` and `color="secondary"`. */
    groupedContainedSecondary: {},
    /** Styles applied to the last button in the button group. */
    lastButton: {
      borderTopRightRadius: o.rounding(e.md),
      borderBottomRightRadius: o.rounding(e.md)
    },
    /** Styles applied to buttons in the middle of the button group. */
    middleButton: {}
  }
}), G = (o) => ({
  defaultProps: {
    size: "medium",
    color: "primary",
    disableRipple: !0
  },
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: r }) => {
      const t = r.disabled, a = r.checked ? o.palette.primary[700] : o.palette.grey[300];
      return {
        margin: i.none,
        padding: i.none,
        "&:hover": !t && {
          "& .MuiSwitch-track": {
            backgroundColor: `${a} !important`
          }
        },
        "&:focus-visible": !t && {
          outline: "none !important",
          borderRadius: o.rounding(e.xl),
          boxShadow: "0px 0px 0px 2px rgba(205, 216, 233, 0.34)"
        }
      };
    },
    /** Styles applied to the root element if `edge="start"`. */
    edgeStart: {},
    /** Styles applied to the root element if `edge="end"`. */
    edgeEnd: {},
    /** Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: ({ ownerState: r }) => {
      const t = r.size === "small";
      return {
        padding: `${i.none} !important`,
        margin: t ? o.spacing(i.xxs) : i.none,
        transitionDuration: "200ms",
        color: o.palette.common.white,
        backgroundColor: "transparent !important"
      };
    },
    /** Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {},
    /** Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 36,
      height: 20
    },
    /** Styles applied to the root element if `size="medium"`. */
    sizeMedium: {
      width: 44,
      height: 24
    },
    /** State class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},
    /** State class applied to the internal SwitchBase component's disabled class. */
    disabled: {},
    /** Styles applied to the internal SwitchBase component's input element. */
    input: {},
    /** Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: ({ ownerState: r }) => {
      const t = r.size === "small", n = r.disabled, a = t ? 16 : 20;
      return {
        boxShadow: "0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)",
        boxSizing: "border-box",
        margin: t ? i.none : o.spacing(i.xxs),
        width: `${a}px !important`,
        height: `${a}px !important`,
        color: `${n ? o.palette.grey[50] : o.palette.common.white} !important`
      };
    },
    /** Styles applied to the track element. */
    track: ({ ownerState: r }) => {
      const t = r.checked, n = r.disabled, a = t ? o.palette.primary[100] : o.palette.grey[300], s = t ? o.palette.primary[600] : o.palette.grey[200], c = n ? a : s;
      return {
        borderRadius: o.rounding(e.xl),
        opacity: "1 !important",
        backgroundColor: `${c} !important`,
        transition: o.transitions.create(["background-color"], {
          duration: 200
        })
      };
    }
  }
}), U = (o) => ({
  defaultProps: {
    disableRipple: !0
  },
  variants: [
    {
      props: { size: "medium" },
      style: {
        ...l(20)
      }
    }
  ],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: r }) => {
      const t = r.disabled;
      return {
        padding: i.none,
        "& svg": {
          borderRadius: o.rounding(e.full)
        },
        "&:focus-visible": {
          "& svg": {
            boxShadow: v.grey
          }
        },
        "&.Mui-checked": {
          color: t ? o.palette.grey[300] : o.palette.primary[600],
          background: t ? o.palette.grey[50] : "transparent",
          "& svg": {
            boxShadow: t ? "none" : v.grey
          }
        },
        "&.Mui-disabled": {
          "& svg": {
            boxShadow: "none",
            color: o.palette.grey[300],
            background: t ? o.palette.grey[50] : "transparent"
          }
        }
      };
    },
    /** State class applied to the root element if `checked={true}`. */
    checked: {
      // not needed field, all styles were configured in root level by MUI by default
      // styles will not have any effect for the component
    },
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {
      // not needed field, all styles were configured in root level by MUI by default
      // styles will not have any effect for the component
    },
    /** Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: o.palette.grey[300]
    },
    /** Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      ...l(16)
    }
  }
}), C = (o, r) => ({
  color: r ? o.palette.grey[300] : o.palette.primary[600],
  background: r ? o.palette.grey[50] : "transparent"
}), q = (o) => ({
  defaultProps: {
    disableRipple: !0
  },
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: r }) => {
      const t = !!r.disabled;
      return {
        padding: i.none,
        borderRadius: o.rounding(e.none),
        position: "relative",
        "&:focus-visible": {
          color: "#155EEF",
          // <--- this color doesn't exist it color palette and marked in the DS as 'not-used'
          "&:before": {
            content: '""',
            position: "absolute",
            top: 3,
            bottom: 3,
            left: 1,
            right: 1,
            borderRadius: o.rounding(e.xs),
            boxShadow: v.grey
          }
        },
        "&.MuiCheckbox-indeterminate": {
          ...C(o, t)
        },
        "&.Mui-checked": {
          ...C(o, t)
        },
        "&.Mui-disabled": {
          "& svg": {
            borderRadius: o.rounding(e.xs),
            boxShadow: "none",
            color: o.palette.grey[300],
            background: t ? o.palette.grey[50] : "transparent"
          }
        }
      };
    },
    /** State class applied to the root element if `checked={true}`. */
    checked: {
      // not needed field, all styles were configured in root level by MUI by default
      // styles will not have any effect for the component
    },
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {
      // not needed field, all styles were configured in root level by MUI by default
      // styles will not have any effect for the component
    },
    /** State class applied to the root element if `indeterminate={true}`. */
    indeterminate: {
      // not needed field, all styles were configured in root level by MUI by default
      // styles will not have any effect for the component
    },
    /** Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: o.palette.grey[300]
    },
    /** Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      ...l(16)
    },
    /** State class applied to the root element if `size="medium"`. */
    sizeMedium: {
      ...l(20)
    }
  }
}), j = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      fontSize: 14,
      lineHeight: "20px",
      fontWeight: o.typography.fontWeightMedium,
      marginBottom: o.spacing(i.sm),
      color: o.palette.grey[700],
      "&.Mui-focused": {
        color: o.palette.grey[700]
      }
    },
    /** Styles applied to the root element if the color is secondary. */
    colorSecondary: {},
    /** State class applied to the root element if `focused={true}`. */
    focused: {},
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {},
    /** State class applied to the root element if `error={true}`. */
    error: {},
    /** State class applied to the root element if `filled={true}`. */
    filled: {},
    /** State class applied to the root element if `required={true}`. */
    required: {},
    /** Styles applied to the asterisk element. */
    asterisk: {}
  }
}), N = ({ color: o, theme: r }) => {
  switch (o) {
    case "error":
      return {
        borderColor: r.palette.error[300],
        focusBoxShadow: d.error,
        endIconColor: r.palette.error[500]
      };
    case "warning":
      return {
        borderColor: r.palette.warning[300],
        focusBoxShadow: d.error,
        endIconColor: r.palette.warning[500]
      };
    default:
      return {
        borderColor: r.palette.grey[300],
        focusBorderColor: r.palette.primary[300],
        focusBoxShadow: d.primaryXs,
        endIconColor: r.palette.grey[400]
      };
  }
}, w = {
  width: "18px",
  height: "18px"
}, J = (o) => ({
  defaultProps: {
    size: "small"
  },
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: r }) => {
      const t = !!r.disabled, { borderColor: n, focusBoxShadow: a, focusBorderColor: s, endIconColor: c } = N({
        theme: o,
        color: r.color
      });
      return {
        border: `1px solid ${n}`,
        boxShadow: p.xs,
        background: t ? o.palette.grey[50] : "inherit",
        borderRadius: o.rounding(e.md),
        fontSize: 14,
        lineHeight: "20px",
        height: "auto",
        backgroundColor: o.palette.common.white,
        color: o.palette.grey[900],
        // TODO: understand why this padding is not aligned to the DS spacings
        padding: r.rows ? "10px 13px" : "6px 11px",
        "& .MuiInputAdornment-positionStart": {
          color: o.palette.grey[500],
          ...w
        },
        "& .MuiInputAdornment-positionEnd": {
          color: c,
          ...w
        },
        "&:focus-visible": {
          border: `1px solid ${s ?? n}`,
          boxShadow: a,
          outline: "none !important"
        },
        "&.Mui-focused": {
          border: `1px solid ${s ?? n}`,
          boxShadow: a,
          outline: "none !important"
        },
        "&::placeholder": {
          color: o.palette.grey[500],
          opacity: 1
        }
      };
    },
    /** Styles applied to the root element if the color is secondary. */
    colorSecondary: {},
    /** Styles applied to the root element if the component is focused. */
    focused: {},
    /** Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},
    /** Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},
    /** State class applied to the root element if `error={true}`. */
    error: {},
    /** Styles applied to the input element if `size="small"`. */
    sizeSmall: {},
    /** Styles applied to the root element if `multiline={true}`. */
    multiline: {},
    /** Styles applied to the NotchedOutline element. */
    notchedOutline: {
      display: "none"
    },
    /** Styles applied to the input element. */
    input: {},
    inputSizeSmall: {
      padding: i.none
    },
    /** Styles applied to the input element if `multiline={true}`. */
    inputMultiline: {},
    /** Styles applied to the input element if `startAdornment` is provided. */
    inputAdornedStart: {},
    /** Styles applied to the input element if `endAdornment` is provided. */
    inputAdornedEnd: {},
    /** Styles applied to the input element if `type="search"`. */
    inputTypeSearch: {}
  }
}), Y = (o) => ({
  defaultProps: {},
  variants: [
    {
      props: { error: !0 },
      style: {
        color: `${o.palette.error[500]} !important`
      }
    },
    {
      props: { warning: !0 },
      style: {
        color: `${o.palette.warning[500]} !important`
      }
    }
  ],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      fontSize: 14,
      lineHeight: "20px",
      marginTop: o.spacing(i.sm),
      marginRight: i.none,
      marginLeft: i.none,
      color: o.palette.grey[600],
      fontWeight: o.typography.fontWeightRegular,
      wordBreak: "break-word"
    },
    /** State class applied to the root element if `error={true}`. */
    error: {},
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {},
    /** Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {},
    /** State class applied to the root element if `focused={true}`. */
    focused: {},
    /** State class applied to the root element if `filled={true}`. */
    filled: {},
    /** State class applied to the root element if `required={true}`. */
    required: {}
  }
}), x = {
  border: "none",
  background: "none",
  boxShadow: "none"
}, _ = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      "& .MuiInputBase-sizeSmall": {
        // TODO: understand why this padding is not aligned to the DS spacings
        padding: "8px 10px !important"
      },
      "& .MuiInputAdornment-positionStart": {
        marginRight: 0
      },
      "& .MuiInputAdornment-positionStart ~ .MuiAutocomplete-tag ~ .MuiAutocomplete-tag": {
        marginLeft: "3px"
      }
    },
    /** Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},
    /** State class applied to the root element if the listbox is displayed. */
    expanded: {},
    /** State class applied to the root element if focused. */
    focused: {},
    /** Styles applied to the option elements if they are keyboard focused. */
    focusVisible: {},
    /** Styles applied to the tag elements, for example the chips. */
    tag: {
      borderRadius: o.rounding(e.sm),
      marginLeft: o.spacing(i.md)
    },
    /** Styles applied to the tag elements, for example the chips if `size="small"`. */
    tagSizeSmall: {},
    /** Styles applied to the tag elements, for example the chips if `size="medium"`. */
    tagSizeMedium: {},
    /** Styles applied when the popup icon is rendered. */
    hasPopupIcon: {},
    /** Styles applied when the clear icon is rendered. */
    hasClearIcon: {},
    /** Styles applied to the Input element. */
    inputRoot: ({ ownerState: r }) => ({
      overflow: "auto",
      maxHeight: 81,
      "&:has(.MuiAutocomplete-tag)": {
        padding: "5.5px 10px !important"
      },
      "&.MuiOutlinedInput-root:not(.Mui-error)": {
        ...!!r.popupOpen && {
          borderColor: o.palette.primary[300],
          boxShadow: d.primaryXs,
          border: `1px solid ${o.palette.primary[300]}`
        }
      }
    }),
    /** Styles applied to the input element. */
    input: ({ ownerState: r }) => ({
      marginRight: r.forcePopupIcon ? o.spacing(i["3xl"]) : i.none
    }),
    /** Styles applied to the input element if the input is focused. */
    inputFocused: {},
    /** Styles applied to the endAdornment element. */
    endAdornment: {},
    /** Styles applied to the clear indicator. */
    clearIndicator: {},
    /** Styles applied to the popup indicator. */
    popupIndicator: {
      ...x,
      "&:hover": {
        ...x
      },
      "&:active": {
        ...x
      },
      "&:focus": {
        ...x
      },
      ...T(o.palette.grey[500])
    },
    /** Styles applied to the popup indicator if the popup is open. */
    popupIndicatorOpen: {},
    /** Styles applied to the popper element. */
    popper: {
      marginTop: `${o.spacing(i.md)} !important`
    },
    /** Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {},
    /** Styles applied to the Paper component. */
    paper: {
      borderRadius: `${o.rounding(e.sm)} !important`,
      boxShadow: p.lg,
      border: `1px solid ${o.palette.grey[200]}`
    },
    /** Styles applied to the listbox component. */
    listbox: {
      "& .MuiAutocomplete-option.Mui-focused": {
        backgroundColor: `${o.palette.grey[50]} !important`
      },
      '& .MuiAutocomplete-option[aria-selected="true"]': {
        backgroundColor: `${o.palette.grey[50]} !important`
      },
      '& .MuiAutocomplete-option[aria-disabled="true"]': {
        backgroundColor: `${o.palette.grey[25]} !important`,
        color: o.palette.grey[500],
        "& svg": {
          color: o.palette.grey[400]
        }
      },
      padding: o.spacing(i.xs, i.none),
      scrollbarColor: `${o.palette.grey[200]} ${o.palette.grey[300]}`
    },
    /** Styles applied to the loading wrapper. */
    loading: {},
    /** Styles applied to the no option wrapper. */
    noOptions: {},
    /** Styles applied to the option elements. */
    option: {
      display: "flex",
      justifyContent: "space-between !important",
      alignItems: "center",
      margin: o.spacing(i.xxs, i.xs),
      // TODO: understand why this padding is not aligned to the DS spacings
      padding: "10px 8px !important",
      color: o.palette.grey[900],
      borderRadius: o.rounding(e.sm),
      "& svg": {
        maxWidth: "20px",
        maxHeight: "20px"
      },
      "& p": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: "100%",
        fontSize: "14px"
      },
      [`& .${D}`]: {
        color: o.palette.primary[600],
        "& svg": {
          width: "20px",
          height: "20px"
        }
      },
      "& .Mui-disabled": {
        background: `${o.palette.grey[25]} !important`,
        color: o.palette.grey[500]
      },
      "& .Mui-focused": {
        background: `${o.palette.grey[50]} !important`
      },
      "&:hover": {
        background: `${o.palette.grey[50]} !important`
      }
    },
    /** Styles applied to the group's label elements. */
    groupLabel: {},
    /** Styles applied to the group's ul elements. */
    groupUl: {}
  }
}), K = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the Popper component. */
    popper: {
      "& .MuiTooltip-arrow": {
        overflow: "visible"
      }
    },
    /** Styles applied to the Popper component unless `disableInteractive={true}`. */
    popperInteractive: {},
    /** Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: {},
    /** Styles applied to the Popper component unless the tooltip is open. */
    popperClose: {},
    /** Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      background: o.palette.grey[900],
      boxShadow: p.lg,
      borderRadius: o.rounding(e.sm),
      padding: o.spacing(i.md, i.lg)
    },
    /** Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      overflow: "visible"
    },
    /** Styles applied to the arrow element. */
    arrow: {
      color: o.palette.grey[900],
      zIndex: -1,
      "&:before": {
        borderRadius: o.rounding(e.xxs)
      }
    },
    /** Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {},
    /** Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: {},
    /** Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: {},
    /** Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: {},
    /** Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: {}
  }
}), Q = (o) => ({
  defaultProps: {},
  variants: [
    {
      props: { type: g.underline },
      style: {
        padding: 0,
        height: 32,
        minHeight: 32,
        overflow: "visible",
        "& .MuiTab-root": {
          "&:not(:first-child)": {
            marginLeft: o.spacing(i.lg)
          },
          height: 32,
          minHeight: 32,
          lineHeight: "20px",
          padding: o.spacing(i.none, i.xs, i.lg),
          fontWeight: o.typography.fontWeightSemibold,
          transition: "color 0.2s ease-in-out, border-color 0.2s ease-in-out",
          position: "relative",
          overflow: "visible",
          "&.Mui-selected": {
            color: o.palette.primary[700],
            "& .MuiTab-iconWrapper": {
              color: o.palette.primary[700],
              background: o.palette.primary[50],
              borderColor: o.palette.primary[200]
            }
          },
          "& .MuiTab-iconWrapper": {
            transition: "color 0.2s ease-in-out, background 0.2s ease-in-out, border-color 0.2s ease-in-out"
          },
          "&:hover": {
            color: o.palette.primary[700],
            "& .MuiTab-iconWrapper": {
              color: o.palette.primary[700],
              background: o.palette.primary[50],
              borderColor: o.palette.primary[200]
            }
          }
        }
      }
    },
    {
      props: { type: g.contained },
      style: {
        minHeight: "44px",
        background: o.palette.grey[50],
        borderRadius: o.rounding(e.full),
        padding: 0,
        border: `1px solid ${o.palette.grey[200]}`,
        "& .MuiTab-root": {
          padding: o.spacing(i.md, i.lg),
          minHeight: "36px",
          height: "36px",
          fontWeight: o.typography.fontWeightSemibold,
          borderRadius: o.rounding(e.full),
          "&.Mui-selected": {
            color: o.palette.primary[600],
            boxShadow: p.sm,
            background: o.palette.common.white
          }
        }
      }
    }
  ],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: r }) => r.type === g.contained && r.size === A.md ? {
      minHeight: "56px !important",
      "& .MuiTab-root": {
        minHeight: "44px !important",
        height: "44px !important"
      }
    } : {},
    /** Styles applied to the root element if `orientation="vertical"`. */
    vertical: {},
    /** Styles applied to the flex container element. */
    flexContainer: ({ ownerState: r }) => {
      const t = r.type === g.underline, n = !!r.hasBottomBorder;
      return {
        flexGrow: 1,
        position: "relative",
        borderBottom: t && n ? `1px solid ${o.palette.grey[200]}` : "none",
        ...t && {
          "& .MuiTab-root": {
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: n ? -1 : -0.5,
              left: 0,
              width: "100%",
              height: "2px",
              background: "transparent",
              transition: "background 0.2s ease-in-out"
            },
            "&:hover": {
              "&::after": {
                background: o.palette.primary[700]
              }
            }
          }
        }
      };
    },
    /** Styles applied to the flex container element if `orientation="vertical"`. */
    flexContainerVertical: {},
    /** Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
    centered: {},
    /** Styles applied to the tablist element. */
    scroller: ({ ownerState: r }) => {
      const t = r.type === g.underline;
      return {
        display: "flex",
        alignItems: "center",
        padding: o.spacing(i.none, i.xs),
        // Prevents badge and hover indicator from cropping
        ...t && {
          paddingBottom: "1px",
          marginBottom: "-1px",
          paddingTop: "4px",
          marginTop: "-4px"
        }
      };
    },
    /** Styles applied to the tablist element if `!variant="scrollable"` */
    fixed: {},
    /** Styles applied to the tablist element if `variant="scrollable"` and `orientation="horizontal"`. */
    scrollableX: {},
    /** Styles applied to the tablist element if `variant="scrollable"` and `orientation="vertical"`. */
    scrollableY: {},
    /** Styles applied to the tablist element if `variant="scrollable"` and `visibleScrollbar={false}`. */
    hideScrollbar: {},
    /** Styles applied to the ScrollButtonComponent component. */
    scrollButtons: {},
    /** Styles applied to the ScrollButtonComponent component if `allowScrollButtonsMobile={true}`. */
    scrollButtonsHideMobile: {},
    /** Styles applied to the TabIndicator component. */
    indicator: ({ ownerState: r }) => {
      const t = r.type === g.underline;
      return {
        display: t ? "block" : "none",
        background: t ? o.palette.primary[700] : o.palette.primary[600]
      };
    }
  }
}), Z = (o) => ({
  defaultProps: {
    disableRipple: !0
  },
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      color: o.palette.grey[800],
      minWidth: "0 !important",
      whiteSpace: "nowrap",
      "&.Mui-disabled": {
        color: o.palette.grey[500]
      }
    },
    /** Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {},
    /** Styles applied to the root element if the parent [`Tabs`](/material-ui/api/tabs/) has `textColor="inherit"`. */
    textColorInherit: {},
    /** Styles applied to the root element if the parent [`Tabs`](/material-ui/api/tabs/) has `textColor="primary"`. */
    textColorPrimary: {},
    /** Styles applied to the root element if the parent [`Tabs`](/material-ui/api/tabs/) has `textColor="secondary"`. */
    textColorSecondary: {},
    /** State class applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},
    /** State class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},
    /** Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {},
    /** Styles applied to the root element if `wrapped={true}`. */
    wrapped: {},
    /** Styles applied to the `icon` HTML element if both `icon` and `label` are provided. */
    iconWrapper: {
      borderRadius: e.full,
      border: `1px solid ${o.palette.grey[200]}`,
      background: o.palette.grey[50],
      padding: o.spacing(i.xxs, i.md),
      color: o.palette.grey[700]
    }
  }
}), oo = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {},
    /** Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {},
    /** Styles applied to the container element if `scroll="body"`. */
    scrollBody: {},
    /** Styles applied to the container element. */
    container: {},
    /** Styles applied to the Paper component. */
    paper: {
      background: o.palette.common.white,
      borderRadius: o.rounding(e.xl),
      boxShadow: p.xl
    },
    /** Styles applied to the Paper component if `scroll="paper"`. */
    paperScrollPaper: {},
    /** Styles applied to the Paper component if `scroll="body"`. */
    paperScrollBody: {},
    /** Styles applied to the Paper component if `maxWidth=false`. */
    paperWidthFalse: {},
    /** Styles applied to the Paper component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: "334px"
    },
    /** Styles applied to the Paper component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: "400px"
    },
    /** Styles applied to the Paper component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: "520px"
    },
    /** Styles applied to the Paper component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: "544px"
    },
    /** Styles applied to the Paper component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: "1080px"
    },
    /** Styles applied to the Paper component if `fullWidth={true}`. */
    paperFullWidth: {
      // TODO: add `maxWidth` once bigger dialog will be added
    },
    /** Styles applied to the Paper component if `fullScreen={true}`. */
    paperFullScreen: {}
  }
}), ro = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: ({ ownerState: r }) => {
      const t = r.sizes, n = o.spacing(P[t]), a = R[t];
      return {
        position: "relative",
        "& .MuiAvatar-root": {
          position: "relative",
          zIndex: "auto",
          boxSizing: "border-box",
          border: "none",
          width: n,
          height: n,
          fontSize: a,
          fontWeight: o.typography.fontWeightMedium,
          color: o.palette.grey[600],
          marginLeft: `${o.spacing(-i.md)} !important`,
          transition: o.transitions.create(["z-index"], {
            duration: o.transitions.duration.standard
          })
        },
        '& div[role="tooltip"]:last-child .MuiAvatar-root': {
          marginLeft: `${i.none} !important`
        }
      };
    },
    /** Styles applied to the avatar elements. */
    avatar: {
      position: "relative",
      zIndex: 1
    }
  }
}), io = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      height: 8,
      width: "100%"
    },
    /** Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
    colorPrimary: {
      backgroundColor: o.palette.grey[200],
      borderRadius: o.rounding(e.xs)
    },
    /** Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {},
    /** Styles applied to the root element if `variant="determinate"`. */
    determinate: {},
    /** Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},
    /** Styles applied to the root element if `variant="buffer"`. */
    buffer: {},
    /** Styles applied to the root element if `variant="query"`. */
    query: {},
    /** Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {},
    /** Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
    dashedColorPrimary: {},
    /** Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
    dashedColorSecondary: {},
    /** Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      backgroundColor: o.palette.primary[600],
      borderRadius: o.rounding(e.xs)
    },
    /** Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {},
    /** Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {},
    /** Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {},
    /** Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {},
    /** Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {},
    /** Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {},
    /** Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {}
  }
}), to = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      ...o.typography.body2,
      borderBottom: "none",
      borderTop: `1px solid ${o.palette.grey[200]}`,
      padding: o.spacing(i.lg, i.md),
      "&:first-of-type": {
        paddingLeft: o.spacing(i.lg)
      },
      "&:last-of-type": {
        paddingRight: o.spacing(i.lg)
      }
    },
    /** Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      fontWeight: o.typography.fontWeightMedium,
      paddingTop: o.spacing(i.lg),
      paddingBottom: o.spacing(i.lg),
      color: o.palette.grey[950]
    },
    /** Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: o.palette.grey[700]
    },
    /** Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {},
    /** Styles applied to the root element if `size="medium"`. */
    sizeMedium: {},
    /** Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {},
    /** Styles applied to the root element if `padding="none"`. */
    paddingNone: {},
    /** Styles applied to the root element if `align="left"`. */
    alignLeft: {},
    /** Styles applied to the root element if `align="center"`. */
    alignCenter: {},
    /** Styles applied to the root element if `align="right"`. */
    alignRight: {},
    /** Styles applied to the root element if `align="justify"`. */
    alignJustify: {},
    /** Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {}
  }
}), eo = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      "& .MuiTableCell-root.MuiTableCell-head": {
        background: o.palette.grey[50]
      },
      "& .MuiTableCell-root.MuiTableCell-body": {
        background: o.palette.common.white
      },
      "&:nth-of-type(even) .MuiTableCell-root.MuiTableCell-body": {
        background: o.palette.grey[50]
      }
    },
    /** State class applied to the root element if `selected={true}`. */
    selected: {},
    /** State class applied to the root element if `hover={true}`. */
    hover: {},
    /** Styles applied to the root element if table variant="head". */
    head: {
      background: o.palette.grey[50],
      "&:first-child .MuiTableCell-root": {
        borderTop: "none"
      }
    },
    /** Styles applied to the root element if table variant="footer". */
    footer: {}
  }
}), ao = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      ...o.typography.body2,
      fontWeight: o.typography.fontWeightMedium,
      color: o.palette.grey[600],
      width: 40,
      height: 40,
      margin: o.spacing(0, i.xxs),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: o.rounding(e.md),
      "&:hover": {
        background: "none"
      },
      "&.Mui-selected": {
        backgroundColor: o.palette.grey[50],
        color: o.palette.grey[800],
        "&:hover": {
          backgroundColor: o.palette.grey[50]
        }
      }
    },
    /** Styles applied to the root element if `type="page"`. */
    page: {},
    /** Styles applied to the root element if `size="small"`. */
    sizeSmall: {},
    /** Styles applied to the root element if `size="large"`. */
    sizeLarge: {},
    /** Styles applied to the root element if `variant="text"`. */
    text: {},
    /** Styles applied to the root element if `variant="outlined"`. */
    outlined: {},
    /** Styles applied to the root element if `rounded="true"`. */
    rounded: {},
    /** Styles applied to the root element if `type="start-ellipsis"` or `type="end-ellipsis"`. */
    ellipsis: {},
    /** Styles applied to the root element if `type="first"` or type="last". */
    firstLast: {},
    /** Styles applied to the root element if `type="previous"` or type="next". */
    previousNext: {},
    /** State class applied to the root element if keyboard focused. */
    focusVisible: {},
    /** State class applied to the root element if `disabled={true}`. */
    disabled: {},
    /** State class applied to the root element if `selected={true}`. */
    selected: {},
    /** Styles applied to the icon to display. */
    icon: {},
    /** Styles applied to the root element if `color="primary"`. */
    colorPrimary: {},
    /** Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {}
  }
}), no = (o) => ({
  defaultProps: {},
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      background: o.palette.grey[200]
    },
    /** Styles applied to the root element if `variant="text"`. */
    text: {
      borderRadius: o.rounding(e["2xl"]),
      transform: "none"
    },
    /** Styles applied to the root element if `variant="rectangular"`. */
    rectangular: {
      borderRadius: o.rounding(e.xs)
    },
    /** Styles applied to the root element if `variant="rounded"`. */
    rounded: {
      borderRadius: e.full
    },
    /** Styles applied to the root element if `variant="circular"`. */
    circular: {},
    /** Styles applied to the root element if `animation="pulse"`. */
    pulse: {},
    /** Styles applied to the root element if `animation="wave"`. */
    wave: {},
    /** Styles applied when the component is passed children. */
    withChildren: {},
    /** Styles applied when the component is passed children and no width. */
    fitContent: {},
    /** Styles applied when the component is passed children and no height. */
    heightAuto: {}
  }
}), po = (o) => ({
  defaultProps: {
    size: "small"
  },
  variants: [],
  styleOverrides: {
    /** Styles applied to the root element. */
    root: {
      ...z.caption,
      padding: "10px 14px",
      "&::before": { display: "none" },
      "&::after": { display: "none" },
      "& .MuiIconButton-root": {
        "& svg": {
          height: "16px",
          width: "14px"
        },
        right: 10
      },
      "&.Mui-disabled .MuiIconButton-root": {
        border: "none",
        boxShadow: "none"
      }
    },
    /** Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},
    /** Styles applied to the root element if the component is focused. */
    focused: {},
    /** Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /** Styles applied to the root element if color secondary. */
    colorSecondary: {},
    /** Styles applied to the root element unless `disableUnderline={true}`. */
    underline: {},
    /** State class applied to the root element if `error={true}`. */
    error: {},
    /** Styles applied to the input element if `size="small"`. */
    sizeSmall: {},
    /** Styles applied to the root element if `multiline={true}`. */
    multiline: {},
    /** Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},
    /** Styles applied to the input element. */
    input: {
      "&.Mui-disabled": {
        color: o.palette.grey[500]
      }
    },
    /** Styles applied to the input element if `size="small"`. */
    inputSizeSmall: {},
    /** Styles applied to the input element if `multiline={true}`. */
    inputMultiline: {},
    /** Styles applied to the input element if `startAdornment` is provided. */
    inputAdornedStart: {},
    /** Styles applied to the input element if `endAdornment` is provided. */
    inputAdornedEnd: {},
    /** Styles applied to the input element if `type="search"`. */
    inputTypeSearch: {}
  }
}), $ = (o) => ({
  MuiCssBaseline: {
    styleOverrides: () => ({
      body: {
        lineHeight: 1
      }
    })
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiBreadcrumbs: W(o),
  MuiTypography: F(),
  MuiButton: V(o),
  MuiIconButton: h(o),
  MuiButtonGroup: X(o),
  MuiSwitch: G(o),
  MuiRadio: U(o),
  MuiCheckbox: q(o),
  MuiChip: L(o),
  MuiFormLabel: j(o),
  MuiInput: po(o),
  MuiOutlinedInput: J(o),
  MuiFormHelperText: Y(o),
  MuiAutocomplete: _(o),
  MuiTooltip: K(o),
  MuiTabs: Q(o),
  MuiTab: Z(o),
  MuiDialog: oo(o),
  MuiAvatar: O(o),
  MuiAvatarGroup: ro(o),
  MuiLinearProgress: io(o),
  MuiTableCell: to(o),
  MuiTableRow: eo(o),
  MuiPaginationItem: ao(o),
  MuiSkeleton: no(o)
}), B = {
  breakpoints: {
    values: E
  },
  palette: H,
  typography: z
}, Er = () => {
  const o = y(B);
  return o.rounding = (r) => typeof r == "number" ? r * o.shape.borderRadius : r, y(o, {
    components: $(o)
  });
}, Fr = (o) => {
  const r = y(B);
  return r.rounding = (t) => typeof t == "number" ? t * r.shape.borderRadius : t, y(r, {
    components: {
      ...$(r),
      MuiPopover: {
        defaultProps: {
          container: () => o
        }
      },
      MuiPopper: {
        defaultProps: {
          container: () => o
        }
      },
      MuiModal: {
        defaultProps: {
          container: () => o
        }
      }
    }
  });
};
export {
  Fr as a,
  Er as c
};
